<template>
    <div class="row">
        <div class="col-md-8">
            <div class="apprentice-simple-card">
                <h2>{{ $t('school.not_connected') }}</h2>
                <p>{{ $t('school.this_school_is_not_connected_to_a_las_location_yet') }}</p>

                <div class="card-title">Voer LAS-gegevens in</div>
                <b-form-group
                    id="provider-group"
                    :label="$t('school.supplier')"
                    label-for="provider-input">
                    <design-2021-apprentice-multiselect-component
                        class="apprentice-select with-border provider-select"
                        id="provider-input"
                        v-model="provider"
                        :multiple-select="false"
                        :options="providers"
                        track-by="name"
                        :label="$t('school.supplier')"
                        @input="resetFields"
                        :allow-empty="false">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>
                <div v-if="provider.name === 'magister'">
                    <b-form-group
                        id="input-group-brin"
                        :label="$t('school.brin')"
                        label-for="input-brin">
                        <b-form-input
                            id="input-brin"
                            v-model="brin"></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-brin"
                        :label="$t('school.brin_location_number')"
                        label-for="input-brin">
                        <b-form-input
                            id="input-brin"
                            v-model="brinAddition"></b-form-input>
                    </b-form-group>
                </div>
                <div v-else-if="provider.name === 'somtoday-connect'">
                    <b-tabs>
                        <b-tab
                            class="apprentice-tab"
                            :title="$t('school.with_brin')">
                            <br />
                            <b-form-group
                                id="input-group-brin"
                                :label="$t('school.brin')"
                                label-for="input-brin">
                                <b-form-input
                                    id="input-brin"
                                    v-model="brin"></b-form-input>
                            </b-form-group>

                            <b-button
                                class="col-4 offset-8 btn btn-primary"
                                variant="primary"
                                @click="findSomtodayConnectSchool"
                                > {{$t('school.retrieve_locations')}}
                            </b-button>

                            <b-form-group
                                v-if="organizations.length"
                                :label="$t('school.organization')"
                                label-for="organization-input">
                                <design-2021-apprentice-multiselect-component
                                    class="apprentice-select with-border provider-select"
                                    id="provider-input"
                                    v-model="organization"
                                    :multiple-select="false"
                                    :options="organizations"
                                    value="external_id"
                                    :label="$t('school.organization')"
                                    :disabled="organizations.length <= 1"
                                    @input="setOrganization"
                                    :allow-empty="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>

                            <b-form-group
                                v-if="organization"
                                :label="$t('school.organization')"
                                label-for="organization-input">
                                <design-2021-apprentice-multiselect-component
                                    class="apprentice-select with-border provider-select"
                                    id="provider-input"
                                    v-model="lasLocation"
                                    :multiple-select="false"
                                    :options="organization.locations"
                                    :disabled="organization.locations.length <= 1"
                                    value="external_id"
                                    :label="$t('school.organization')"
                                    @input="setLocation"
                                    :allow-empty="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>
                        </b-tab>
                        <b-tab
                            class="apprentice-tab"
                            :title="$t('school.manual')>
                            <br />
                            <b-form-group
                                id="organization_external_id"
                                :label="$t('school.organization_external_id')"
                                label-for="input-organization-external-id">
                                <b-form-input
                                    id="input-organization-external-id"
                                    v-model="organizationExternalId"></b-form-input>
                                <b-form-text>{{$t('school.organization_external_id_explanation')}}</b-form-text>
                            </b-form-group>
                        </b-tab>
                    </b-tabs>
                </div>

                <b-form-group
                    id="location_external_id"
                    :label="$t('school.location_external_id')"
                    :help="$t('school.location-external_id_explanation')"
                    label-for="input-location-external-id">
                    <b-form-input
                        id="input-location-external-id"
                        v-model="locationExternalId"></b-form-input>
                    <b-form-text>{{$t('school.location-external_id_explanation')}}</b-form-text>
                </b-form-group>
                <b-button
                    class="col-4 offset-8 btn btn-primary"
                    variant="primary"
                    @click="submit"
                    >Opslaan
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-connection-component',
    data() {
        return {
            providers: [
                {
                    name: 'somtoday-connect',
                    label: 'SomToday Connect',
                },
                {
                    name: 'magister',
                    label: 'Magister',
                },
            ],
            provider: {
                name: null,
            },
            brin: null,
            brinAddition: null,
            organizationExternalId: null,
            organization: null,
            locationExternalId: null,
            errors: null, //todo add errors
            organizations: [],
            lasLocation: null,
        };
    },
    methods: {
        findSomtodayConnectSchool() {
            this.alert.loading();
            this.axios.get(this.routes.lasSomtodayConnectLocationByBrin(this.brin)).then(
                (response) => {
                    this.organizations = response.data;
                    if (this.organizations.length === 1) {
                        this.organization = this.organizations[0];
                        this.setOrganization();
                    }
                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        setOrganization() {
            this.organizationExternalId = this.organization.external_id;
            if (this.organization.locations.length === 1) {
                this.lasLocation = this.organization.locations[0];
                this.setLocation();
            }
        },
        setLocation() {
            this.locationExternalId = this.lasLocation.external_id;
        },
        submit() {
            this.alert.saving();

            let data = {
                provider: this.provider.name,
                brin: this.brin,
                brin_addition: this.brinAddition,
                location_external_id: this.locationExternalId,
                organization_external_id: this.organizationExternalId,
            };

            this.axios.post(this.routes.storeLasLocation(), data).then(
                (response) => {
                    window.location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        resetFields() {
            if (this.provider.name === 'magister') {
                this.locationExternalId = null;
            } else if (this.provider.name === 'somtoday-connect') {
                this.brin = null;
                this.brin_addition = null;
            }
        },
    },
};
</script>

<style scoped></style>
